import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.relay.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-relay-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.relay.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraRelayItemComponent implements OnInit, OnDestroy {
    public item: any = null;
    public id: string = '';
    public tab: string = 'overview';
    public editingName: boolean = false;
    public editName: string = '';
    public dhcpApplying: boolean = false;
    private routerSub: any;

    // Deploy tab state
    public deployAvailable: boolean = false;
    public resourceBase: string = '';
    public deployConfig: any = null;
    public deployGroups: any = null;
    public editableVars: any = {};
    public editingEnv: boolean = false;
    public envFormData: any = {};
    public deploying: boolean = false;
    public deployProcessId: number | null = null;
    public deployLogs: any[] = [];
    public selectedLogContent: string = '';
    public selectedLogFilename: string = '';
    public selectedLogMeta: any = null;

    // Zabbix tab state
    public zabbixConfigLoaded: boolean = false;
    public zabbixNodes: any[] = [];
    public selectedZabbixNodeIds: Set<number> = new Set<number>();
    public zabbixProxyNodeId: any = '';
    public zabbixProxyName: string = '';
    public zabbixServerIp: string = '';
    public zabbixSshUser: string = 'root';
    public zabbixSshPassword: string = '';
    public zabbixRunning: boolean = false;
    public zabbixMessage: string = '';
    public zabbixResult: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        await this.load();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href('/kiera/relay');
            return;
        }
        this.item = data;

        // Check deploy availability
        const avail = await wiz.call("deploy_available");
        this.deployAvailable = avail.code === 200 && !!avail.data?.available;
        this.resourceBase = avail.code === 200 ? (avail.data?.resource_base || '') : '';

        await this.service.render();
    }

    public async switchTab(tab: string) {
        this.tab = tab;
        if (tab === 'deploy' && this.deployConfig === null) {
            await this.loadDeployConfig();
        }
        if (tab === 'zabbix') {
            await this.loadRelayZabbixConfig();
        }
        if (tab === 'logs') {
            await this.loadDeployLogs();
        }
        await this.service.render();
    }

    // =========================================================================
    // Name Edit
    // =========================================================================

    public async startEditName() {
        this.editingName = true;
        this.editName = this.item.name;
        await this.service.render();
    }

    public async saveName() {
        if (!this.editName.trim()) return;
        const { code } = await wiz.call("update", { id: this.id, data: JSON.stringify({ name: this.editName }) });
        if (code === 200) {
            this.item.name = this.editName;
            this.editingName = false;
        }
        await this.service.render();
    }

    public async cancelEditName() {
        this.editingName = false;
        await this.service.render();
    }

    public async deleteRelay() {
        if (!confirm(this.translate.instant('page.relay.item.confirm_delete'))) return;
        const { code } = await wiz.call("delete", { id: this.id });
        if (code === 200) this.service.href('/kiera/relay');
    }

    public async applyDhcp() {
        if (this.dhcpApplying) return;
        if (!confirm(this.translate.instant('page.relay.item.confirm_apply_dhcp'))) return;

        this.dhcpApplying = true;
        await this.service.render();

        const { code, data } = await wiz.call("apply_dhcp", { id: this.id });
        this.dhcpApplying = false;

        if (code === 200) {
            const hostCount = data?.host_count || 0;
            alert(this.translate.instant('page.relay.item.apply_dhcp_done', { count: hostCount }));
        } else {
            alert(data?.message || this.translate.instant('page.relay.item.apply_dhcp_failed'));
        }
        await this.service.render();
    }

    // =========================================================================
    // Deploy Config
    // =========================================================================

    public async loadDeployConfig() {
        const { code, data } = await wiz.call("deploy_config");
        if (code === 200) {
            this.deployConfig = data.config || {};
            this.deployGroups = data.groups || {};
            this.editableVars = data.editable_vars || {};
            this.envFormData = { ...this.deployConfig };
        }
        await this.service.render();
    }

    public async startEditEnv() {
        this.editingEnv = true;
        this.envFormData = { ...this.deployConfig };
        await this.service.render();
    }

    public async saveEnv() {
        const { code } = await wiz.call("deploy_save_config", { data: JSON.stringify(this.envFormData) });
        if (code === 200) {
            this.deployConfig = { ...this.envFormData };
            this.editingEnv = false;
            await this.service.render();
        }
    }

    public async cancelEditEnv() {
        this.editingEnv = false;
        this.envFormData = { ...this.deployConfig };
        await this.service.render();
    }

    // =========================================================================
    // Deploy Execute
    // =========================================================================

    public async executeDeploy() {
        if (!confirm(this.translate.instant('page.relay.item.confirm_execute'))) return;
        this.deploying = true;
        await this.service.render();

        const { code, data } = await wiz.call("deploy_execute", { data: JSON.stringify(this.deployConfig) });
        if (code === 200 && data.process_id) {
            this.deployProcessId = data.process_id;
            this.checkDeployStatus();
        } else {
            this.deploying = false;
        }
        await this.service.render();
    }

    private async checkDeployStatus() {
        if (!this.deployProcessId) return;
        const { code, data } = await wiz.call("deploy_status", { process_id: this.deployProcessId });
        if (code === 200 && data.running) {
            setTimeout(() => this.checkDeployStatus(), 3000);
        } else {
            this.deploying = false;
            this.deployProcessId = null;
            await this.loadDeployLogs();
        }
        await this.service.render();
    }

    // =========================================================================
    // Zabbix Commands
    // =========================================================================

    public async loadRelayZabbixConfig() {
        const { code, data } = await wiz.call("relay_zabbix_config", { id: this.id });
        if (code === 200) {
            this.zabbixNodes = data?.nodes || [];
            if (data?.server_ip && !this.zabbixServerIp) {
                this.zabbixServerIp = data.server_ip;
            }
            this.zabbixConfigLoaded = true;
            this.initializeZabbixDefaults();
        }
        await this.service.render();
    }

    private initializeZabbixDefaults() {
        if (!this.zabbixProxyNodeId) {
            const proxy = this.zabbixProxyCandidates()[0];
            if (proxy) this.zabbixProxyNodeId = proxy.id;
        }
        const proxy = this.zabbixProxyNode();
        if (proxy && !this.zabbixProxyName) {
            this.zabbixProxyName = this.defaultZabbixProxyName(proxy);
        }
    }

    private defaultZabbixProxyName(proxy: any): string {
        if (!proxy) return '';
        if (proxy.proxy_name) return String(proxy.proxy_name);
        const nodeName = String(proxy.name || '').trim();
        if (nodeName) return `relay_${nodeName}`;
        return proxy.id ? `relay_${proxy.id}` : '';
    }

    public zabbixProxyCandidates(): any[] {
        return (this.zabbixNodes || []).filter((node: any) => node.role === 'relay' && !!node.ip_address);
    }

    public zabbixProxyNode(): any {
        const proxyId = Number(this.zabbixProxyNodeId || 0);
        if (!proxyId) return null;
        return (this.zabbixNodes || []).find((node: any) => Number(node.id) === proxyId) || null;
    }

    public async onZabbixProxyNodeChanged() {
        const proxy = this.zabbixProxyNode();
        if (proxy) this.zabbixProxyName = this.defaultZabbixProxyName(proxy);
        await this.service.render();
    }

    public isZabbixNodeSelected(nodeId: any): boolean {
        return this.selectedZabbixNodeIds.has(Number(nodeId));
    }

    public async toggleZabbixNodeSelect(nodeId: any) {
        const id = Number(nodeId);
        if (this.selectedZabbixNodeIds.has(id)) {
            this.selectedZabbixNodeIds.delete(id);
        } else {
            this.selectedZabbixNodeIds.add(id);
        }
        await this.service.render();
    }

    public allZabbixNodesSelected(): boolean {
        return this.zabbixNodes.length > 0 && this.zabbixNodes.every((node: any) => this.selectedZabbixNodeIds.has(Number(node.id)));
    }

    public async toggleAllZabbixNodes(event: any) {
        const checked = !!event?.target?.checked;
        this.selectedZabbixNodeIds.clear();
        if (checked) {
            for (const node of this.zabbixNodes) {
                this.selectedZabbixNodeIds.add(Number(node.id));
            }
        }
        await this.service.render();
    }

    public selectedZabbixNodeIdsArray(): number[] {
        return Array.from(this.selectedZabbixNodeIds);
    }

    public getZabbixResultStatusClass(result: any): string {
        if (this.zabbixRunning) return 'bg-indigo-50 text-indigo-700 border-indigo-100';
        if (!result) return 'bg-zinc-50 text-zinc-600 border-zinc-100';
        if (Number(result?.summary?.failed || 0) > 0) return 'bg-red-50 text-red-700 border-red-100';
        if (Number(result?.summary?.api_warnings || 0) > 0) return 'bg-amber-50 text-amber-700 border-amber-100';
        if (Number(result?.summary?.success || 0) > 0) return 'bg-green-50 text-green-700 border-green-100';
        return 'bg-zinc-50 text-zinc-600 border-zinc-100';
    }

    public getZabbixResultStatusText(result: any): string {
        if (this.zabbixRunning) return 'Running';
        if (!result) return 'Ready';
        if (Number(result?.summary?.failed || 0) > 0) return 'Partial failed';
        if (Number(result?.summary?.api_warnings || 0) > 0) return 'Completed with warning';
        if (Number(result?.summary?.success || 0) > 0) return 'Completed';
        return 'Ready';
    }

    public getZabbixRowBadgeClass(row: any): string {
        if (row?.success) return row?.zabbix_api_warning ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700';
        return 'bg-red-100 text-red-700';
    }

    public getZabbixRowIcon(row: any): string {
        if (row?.success) return row?.zabbix_api_warning ? 'bx bx-info-circle text-amber-600' : 'bx bx-check-circle text-green-600';
        return 'bx bx-x-circle text-red-600';
    }

    public getZabbixRowStatusText(row: any): string {
        if (row?.success && row?.zabbix_api_warning) return 'Configured';
        if (row?.success) return 'OK';
        return 'Failed';
    }

    public getZabbixRowMessage(row: any): string {
        return String(row?.message || row?.zabbix_api_message || row?.data || '-');
    }

    public async installRelayZabbixProxy() {
        const proxy = this.zabbixProxyNode();
        if (!proxy) {
            this.zabbixMessage = 'Select a proxy node first.';
            await this.service.render();
            return;
        }
        if (!this.zabbixServerIp) {
            this.zabbixMessage = 'Zabbix Server IP is required.';
            await this.service.render();
            return;
        }
        const proxyName = this.zabbixProxyName || this.defaultZabbixProxyName(proxy);
        if (!confirm(`Install Zabbix Proxy on ${proxy.name}?`)) return;
        this.zabbixRunning = true;
        this.zabbixMessage = `Installing Zabbix Proxy on ${proxy.name}...`;
        this.zabbixResult = {
            action: 'install_proxy',
            results: [],
            summary: { total: 1, success: 0, failed: 0 },
        };
        await this.service.render();
        const { code, data } = await wiz.call("relay_zabbix_install_proxy", {
            id: this.id,
            node_id: proxy.id,
            ssh_user: this.zabbixSshUser,
            ssh_password: this.zabbixSshPassword,
            zabbix_server: this.zabbixServerIp,
            proxy_name: proxyName,
        });
        this.zabbixRunning = false;
        if (code === 200) {
            this.zabbixResult = data || null;
            this.zabbixMessage = data?.message || 'Zabbix Proxy install command completed.';
        } else {
            this.zabbixMessage = data?.message || 'Zabbix Proxy install command failed.';
            this.zabbixResult = {
                action: 'install_proxy',
                results: [{ id: proxy.id, name: proxy.name, success: false, message: this.zabbixMessage }],
                summary: { total: 1, success: 0, failed: 1 },
            };
        }
        await this.loadRelayZabbixConfig();
        await this.service.render();
    }

    public async assignRelayZabbixProxy() {
        const proxy = this.zabbixProxyNode();
        const nodeIds = this.selectedZabbixNodeIdsArray();
        if (!proxy) {
            this.zabbixMessage = 'Select a proxy node first.';
            await this.service.render();
            return;
        }
        if (nodeIds.length === 0) {
            this.zabbixMessage = 'Select nodes to point at the proxy.';
            await this.service.render();
            return;
        }
        const proxyName = this.zabbixProxyName || this.defaultZabbixProxyName(proxy);
        if (!confirm(`Configure ${nodeIds.length} node(s) to use proxy ${proxyName}?`)) return;
        this.zabbixRunning = true;
        this.zabbixMessage = `Configuring ${nodeIds.length} node(s) to use proxy ${proxyName}...`;
        this.zabbixResult = {
            action: 'assign_proxy',
            results: [],
            summary: { total: nodeIds.length, success: 0, failed: 0 },
        };
        await this.service.render();
        const { code, data } = await wiz.call("relay_zabbix_assign_proxy", {
            id: this.id,
            node_ids: JSON.stringify(nodeIds),
            proxy_node_id: proxy.id,
            ssh_user: this.zabbixSshUser,
            ssh_password: this.zabbixSshPassword,
            proxy_name: proxyName,
        });
        this.zabbixRunning = false;
        if (code === 200) {
            this.zabbixResult = data || null;
            const summary = data?.summary || {};
            this.zabbixMessage = `${summary.success || 0} configured, ${summary.failed || 0} failed.`;
        } else {
            this.zabbixMessage = data?.message || 'Zabbix proxy assignment failed.';
            this.zabbixResult = {
                action: 'assign_proxy',
                results: this.zabbixNodes
                    .filter((node: any) => nodeIds.includes(Number(node.id)))
                    .map((node: any) => ({ id: node.id, name: node.name, success: false, message: this.zabbixMessage })),
                summary: { total: nodeIds.length, success: 0, failed: nodeIds.length },
            };
        }
        await this.loadRelayZabbixConfig();
        await this.service.render();
    }

    // =========================================================================
    // Deploy Logs
    // =========================================================================

    public async loadDeployLogs() {
        const { code, data } = await wiz.call("deploy_logs", { id: this.id });
        if (code === 200) {
            this.deployLogs = data || [];
        }
        await this.service.render();
    }

    public async viewLog(log: any) {
        const filename = typeof log === 'string' ? log : (log?.filename || '');
        this.selectedLogMeta = typeof log === 'string' ? { filename } : log;
        this.selectedLogFilename = this.selectedLogMeta?.label || filename;
        const { code, data } = await wiz.call("deploy_log_content", { id: this.id, filename });
        if (code === 200) {
            this.selectedLogContent = data || '';
        }
        await this.service.render();
    }

    public closeLog() {
        this.selectedLogContent = '';
        this.selectedLogFilename = '';
        this.selectedLogMeta = null;
        this.service.render();
    }

    public getIntegratedDeployLogs(): any[] {
        return (this.deployLogs || []).filter((log) => (log?.category || 'integrated') !== 'individual');
    }

    public getIndividualDeployLogs(): any[] {
        return (this.deployLogs || []).filter((log) => log?.category === 'individual');
    }

    // =========================================================================
    // Utils
    // =========================================================================

    public getStatusBadge(status: string): string {
        switch (status) {
            case 'completed': return 'bg-green-100 text-green-700';
            case 'relay-ready': return 'bg-green-100 text-green-700';
            case 'ready': return 'bg-green-100 text-green-700';
            case 'deployed': return 'bg-green-100 text-green-700';
            case 'running': return 'bg-blue-100 text-blue-700';
            case 'deploying': return 'bg-blue-100 text-blue-700';
            case 'pending': return 'bg-amber-100 text-amber-700';
            case 'error': return 'bg-red-100 text-red-700';
            case 'failed': return 'bg-red-100 text-red-700';
            default: return 'bg-zinc-100 text-zinc-600';
        }
    }

    public opaStages(entry: any): any[] {
        return Array.isArray(entry?.opa?.stages) ? entry.opa.stages : [];
    }

    public opaStageStatusLabel(stage: any): string {
        const status = String(stage?.status || 'pending').toLowerCase();
        if (status.includes('complete') || status === 'ready') return '완료';
        if (status.includes('fail') || status.includes('error')) return '실패';
        if (status.includes('run') || status.includes('progress')) return '진행 중';
        return status === 'not-applicable' ? '대상 아님' : '대기';
    }

    public opaStageLightClass(stage: any): string {
        const status = String(stage?.status || 'pending').toLowerCase();
        if (status.includes('complete') || status === 'ready') return 'bg-emerald-500 ring-emerald-100';
        if (status.includes('fail') || status.includes('error')) return 'bg-rose-500 ring-rose-100';
        if (status.includes('run') || status.includes('progress')) return 'bg-blue-500 ring-blue-100 animate-pulse';
        if (status === 'not-applicable') return 'bg-slate-200 ring-slate-100';
        return 'bg-amber-300 ring-amber-100';
    }

    public opaStageTitle(stage: any): string {
        const elapsed = Number(stage?.elapsed_seconds || 0);
        const parts = [String(stage?.label || stage?.key || 'OPA'), this.opaStageStatusLabel(stage)];
        if (elapsed > 0) parts.push(`${Math.round(elapsed)}초`);
        const detail = String(stage?.failure_reason || stage?.message || '').trim();
        if (detail) parts.push(detail);
        return parts.join(' · ');
    }

    public primaryDhcpAuthorityLabel(): string {
        const authorities = this.item?.dhcp_authorities || [];
        if (!authorities.length) return '-';
        return authorities[0]?.authority_label || '-';
    }

    public dhcpAuthoritySummaryText(): string {
        const authorities = this.item?.dhcp_authorities || [];
        if (!authorities.length) return 'not selected';
        if (authorities.length > 1) return `${authorities.length} authority groups`;
        const authority = authorities[0] || {};
        const group = authority.group_label || authority.group_key || '';
        const count = authority.member_count || 0;
        return group ? `${group} · ${count} relay server(s)` : `${count} relay server(s)`;
    }

    public dhcpRoleLabel(role: string): string {
        return role === 'authority' ? 'Authority' : 'Member';
    }

    public getDhcpRoleBadge(role: string): string {
        return role === 'authority'
            ? 'bg-emerald-100 text-emerald-700'
            : 'bg-zinc-100 text-zinc-600';
    }

    public getEnvGroupKeys(groupName: string): string[] {
        if (!this.deployGroups || !this.deployGroups[groupName]) return [];
        return Object.keys(this.deployGroups[groupName]);
    }

    public getGroupNames(): string[] {
        if (!this.deployGroups) return [];
        return Object.keys(this.deployGroups);
    }

    public formatFileSize(bytes: number): string {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
}

export default PageKieraRelayItemComponent;
